import { render, staticRenderFns } from "./ExistingAndPendingInsurance.vue?vue&type=template&id=67927c70"
import script from "./ExistingAndPendingInsurance.vue?vue&type=script&lang=js"
export * from "./ExistingAndPendingInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports